import { render } from "./TotalSigfoxDevices.vue?vue&type=template&id=ec5a47f0&ts=true"
import script from "./TotalSigfoxDevices.vue?vue&type=script&lang=ts"
export * from "./TotalSigfoxDevices.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__